export const nameSpace = 'myFiles.header';
export const buttonsNameSpace = 'myFiles.header.buttons';
